import { ATTACHMENT_TYPE, BlogComment as CommentModel } from '@/models/Posts';
import { getTimeStamp } from '@/utils/helper';
import Paragraph, { VARIANT as PARAGRAPH_VARIANT } from '../Paragraph';
import SubHeading, { VARIANT as SUBHEADING_VARIANT } from '../SubHeading';
import MediaCard from './MediaCard';
import UserVerifiedImage from './UserVerifiedImage';
const BlogComment = ({
  content,
  user,
  created_at,
  attachments,
  type
}: CommentModel) => {
  return <div className="w-full flex my-4" data-sentry-component="BlogComment" data-sentry-source-file="BlogComment.tsx">
      <UserVerifiedImage alt={user.full_name} imageUrl={user.photo_S3_path} isVerified={user.is_verified} data-sentry-element="UserVerifiedImage" data-sentry-source-file="BlogComment.tsx" />
      <div className="w-full ml-2 p-4 bg-neutral-20 rounded-b-3xl rounded-tr-3xl">
        <div className="pb-8 items-center flex-wrap">
          <SubHeading variant={SUBHEADING_VARIANT.SMALL} data-sentry-element="SubHeading" data-sentry-source-file="BlogComment.tsx">
            {user.full_name}
          </SubHeading>
          {user.profile ? <Paragraph variant={PARAGRAPH_VARIANT.SMALL} className="text-neutral-90">
              {user.profile.district !== null ? user.profile.district : ''}
              {user.profile.state !== null ? `, ${user.profile.state}` : ''}
            </Paragraph> : null}
        </div>
        <Paragraph variant={PARAGRAPH_VARIANT.BIG} data-sentry-element="Paragraph" data-sentry-source-file="BlogComment.tsx">{content}</Paragraph>
        {attachments && type !== ATTACHMENT_TYPE.Text ? <div className={`flex justify-center items-center my-4 mx-auto ${type !== ATTACHMENT_TYPE.Audio ? 'h-[300px] md:w-[300px]' : ''}`}>
            <MediaCard attachments={attachments} />
          </div> : null}
        <Paragraph variant={PARAGRAPH_VARIANT.SMALL} className="text-neutral-90 text-right mt-2" data-sentry-element="Paragraph" data-sentry-source-file="BlogComment.tsx">
          {getTimeStamp(created_at)}
        </Paragraph>
      </div>
    </div>;
};
export default BlogComment;